// Centralized API configuration
export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',    
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '',
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET || '',
    REACT_APP_AUTH_BASE_URL: process.env.REACT_APP_AUTH_BASE_URL || '/auth',
    PREQIN_API_URL: process.env.REACT_APP_PREQIN_API_URL || ''
} as const;

// Export individual values for convenience
export const API_BASE_URL = API_CONFIG.BASE_URL;
export const CLIENT_ID = API_CONFIG.CLIENT_ID;
export const CLIENT_SECRET = API_CONFIG.CLIENT_SECRET;
export const AUTH_BASE_URL = API_CONFIG.REACT_APP_AUTH_BASE_URL;
export const PREQIN_API_URL =  API_CONFIG.BASE_URL + API_CONFIG.PREQIN_API_URL;
